module.exports = __webpack_public_path__ + "img/navigation-24px.29ce4096.svg";